<template>
  <v-container>
    <h1>Home</h1>
    <!--another way to query data using ApolloQuery-->
    <ApolloQuery :query="getSetsLib">
      <template
        slot-scope="{ result: { loading, error, data, networkStatus } }"
      >
        <div v-if="loading">On your marks..</div>
        <div v-else-if="error">FalseStart! {{ error.message }}</div>
        <div v-else-if="networkStatus">Network Status: {{ networkStatus }}</div>
        <!--<div v-else-if="loading">Network Status: {{networkStatus}}</div>-->
        <ul v-else v-for="edge in data.allSets.edges" :key="edge.node.setId">
          <!--{{edge}}-->
          <li>
            {{ edge.node.setId }}
            {{ edge.node.setName }}
            {{ edge.node.setDesc }}
          </li>
        </ul>
        <slot></slot>
      </template>
    </ApolloQuery>
  </v-container>
</template>

<script>
import { gql } from "apollo-boost";

export default {
  name: "home",
  data() {
    return {
      getSetsLib: gql`
        query {
          allSets {
            edges {
              node {
                setId
                setName
                setDesc
              }
            }
          }
        }
      `
    };
  }
};
</script>
